import storeConfig from 'Stores/shopify-dawn-generic/config.js';

try {
  storeConfig.InitFunc?.();
} catch (e) {
  console.error(e);
}
